import { query } from '@/utils/request';

// 云平台授权列表
export async function getLicenseList(data) {
  return query('/zlb/api/expense/purchase/license/list', { method: 'POST', data });
}

// 保存授权
export async function saveLicense(data) {
  return query('/zlb/api/expense/purchase/license/save', { method: 'POST', data });
}

// 授权修改（再次授权/取消授权/编辑）
export async function updateLicense(data) {
  return query('/zlb/api/expense/purchase/license/update', { method: 'POST', data });
}

// 删除授权
export async function deleteLicense(params) {
  return query(`/zlb/api/expense/purchase/license/delete/${params.licenseCode}`);
}

// 邮箱授权列表
export function fetchEmailAuthList(params) {
  return query('/zlb/api/sop/authorize/auth-list', { params });
}

// 保存邮箱授权
export function saveEmailAuth(data) {
  return query('/zlb/api/sop/authorize/auth/save', {
    method: 'POST',
    data,
  });
}

// 取消邮箱授权
export function delEmailAuth(data) {
  return query(`/zlb/api/sop/authorize/auth/delete?code=${data}`, {
    method: 'POST',
  });
}

// 协议确认
export function updateEmailAuth(data) {
  return query('/zlb/api/sop/authorize/notice/sign', {
    method: 'POST',
    data,
  });
}

// 查询邮箱是否授权
export function checkEmail(data) {
  return query('/zlb/api/sop/authorize/auth/check', {
    method: 'POST',
    data,
  });
}

// 查询协议确认
export function queryAuth(data) {
  return query('/zlb/api/sop/authorize/notice/check', {
    method: 'POST',
    data,
  });
}
